import axios from 'src/store/vue-axios/axios.js'

// BASE URLs

export default class Monitors {
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // API ENDPOINTS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // PUBLIC special cases -> /${this.$axios.defaults.baseURL}/public/*
  static monitorAttachmentsUrl = (attachmentId, authToken) => `${axios.defaults.baseURL}/public/monitors/single/attachments/${attachmentId}?monitor-token=${authToken}`

  // PUBLIC -> /public/monitors*
  static monitorSingleUrl = () => '/public/monitors/single'

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // API IMPLEMENTATIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // PUBLIC -> /public/monitors*
  static async getMonitorSingle (config) {
    return axios.get(this.monitorSingleUrl(), config)
  }
}
